export default __webpack_public_path__ + "static/media/daet-on-the-go.58502961.png";